import { gql } from 'graphql-request';

export const PUNCH_CLOCK_FIELDS = gql`
  fragment PunchClockHistoryFields on PunchClockDto {
    punchClockId
    userId
    projectId
    organizationId
    action
    time
    createdAt
    geofenceId
    project {
      projectId
      name
      address
    }
    geofence {
      geofenceId
      name
      color
      isActive
      category {
        geofenceCategoryId
        name
        icon
        color
      }
    }
  }
`;

export const getPunchClocksByUser = gql`
  query getPunchClocksByUser($userId: String!, $action: PunchClockAction) {
    getPunchClocksByUser(userId: $userId, action: $action) {
      ...PunchClockHistoryFields
    }
  }
  ${PUNCH_CLOCK_FIELDS}
`;

const PunchClockGraphQL = {
  queries: { getPunchClocksByUser },
};

export default PunchClockGraphQL;
